<p-selectbutton
  data-cy="quote-list-tabs"
  [options]="tabs"
  [ngModel]="active()"
  (onChange)="onTabChange($event.value)"
  optionLabel="label"
  optionValue="value"
  [allowEmpty]="false"
>
  <ng-template #item let-tab>
    <i [class]="tab.icon"></i>
    <span>{{ tab.label }}</span>
    @if (tab.value === newTab) {
      <app-feature-badge kind="new" [inline]="true" />
    }
  </ng-template>
</p-selectbutton>
